import api from '../../api';
interface UserForm {
  name: string;
  email: string;
}

interface PasswordForm {
  old_password: string;
  password: string;
  password_confirmation: string;
}
export async function getUsers(id: number): Promise<any> {
  try {
    const res = await api.get(`/api/v1/users?branch_id=${id}`);
    return res;
  } catch (err) {
    console.log('Get user branch error ', err);
    throw err;
  }
}

export async function getUserInformation(): Promise<any> {
  try {
    const res = await api.get(`/api/user`);
    return res;
  } catch (err) {
    console.log('Get detail user error ', err);
    throw err;
  }
}

export async function updateUserInformation(obj: UserForm): Promise<any> {
  try {
    const res = await api.put(`/api/user/profile`, obj);
    return res;
  } catch (err) {
    console.log('Error updating user', err);
    throw err;
  }
}

export async function updateUserPassword(obj: PasswordForm): Promise<any> {
  try {
    const res = await api.put(`/api/user/password`, obj);
    return res;
  } catch (err) {
    console.log('Error updating Password', err);
    throw err;
  }
}

export const usersService = {
  getUsers,
  getUserInformation,
  updateUserInformation,
  updateUserPassword,
};
